import { render, staticRenderFns } from "./CustomPlaylist.vue?vue&type=template&id=51a51d10&scoped=true&"
import script from "./CustomPlaylist.vue?vue&type=script&lang=js&"
export * from "./CustomPlaylist.vue?vue&type=script&lang=js&"
import style0 from "./CustomPlaylist.vue?vue&type=style&index=0&id=51a51d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a51d10",
  null
  
)

export default component.exports